import { CollapsiblePanel, EmptyCell, PanelCount, PanelSummary, Table, TableWrap, Td, Th } from '../AuditSection';
import { HISTORY_EMPTY_MESSAGE, HISTORY_PANEL_TITLE } from '../constants';
import { displayOrDash, formatShortDateTime } from '../utils';
import type { StatusHistoryProps } from './types';
import { getHistoryPanelCountLabel, getHistoryResolutionLabel, getHistoryStatusLabel } from './utils';

const StatusHistory = ({ history, report, loading = false }: StatusHistoryProps) => {
  const countLabel = getHistoryPanelCountLabel(history.length, report);

  return (
    <CollapsiblePanel open={history.length > 0}>
      <PanelSummary>
        {HISTORY_PANEL_TITLE}
        <PanelCount>{loading ? 'Loading…' : countLabel}</PanelCount>
      </PanelSummary>
      <TableWrap>
        <Table>
          <thead>
            <tr>
              <Th>Timestamp</Th>
              <Th>Status</Th>
              <Th>Resolution</Th>
              <Th>Source</Th>
            </tr>
          </thead>
          <tbody>
            {history.length === 0 ? (
              <tr>
                <EmptyCell colSpan={4}>{HISTORY_EMPTY_MESSAGE}</EmptyCell>
              </tr>
            ) : (
              history.map((item) => (
                <tr key={item.id}>
                  <Td>{formatShortDateTime(item.timestamp)}</Td>
                  <Td>{getHistoryStatusLabel(item)}</Td>
                  <Td>{getHistoryResolutionLabel(item)}</Td>
                  <Td>{displayOrDash(item.source)}</Td>
                </tr>
              ))
            )}
          </tbody>
        </Table>
      </TableWrap>
    </CollapsiblePanel>
  );
};

export default StatusHistory;
